import { ApiHelper } from "shared/helpers/api";
import { getUrl, ROUTES } from "shared/api/urls";
import { IHeadersObject } from "global";

interface IGetInternationalizationDataProps {
    headers?: IHeadersObject;
}

export const getInternationalizationData = ({
    headers,
}: IGetInternationalizationDataProps): Promise<any> => {
    const url = getUrl(ROUTES.COUNTRY_CURRENCY_SETTINGS);
    return ApiHelper(url, { headers }).then((response: Response) => response.json());
};

export const setInternationalizationData = (body: object): Promise<any> => {
    const url = getUrl(ROUTES.SET_COUNTRY_CURRENCY_SETTINGS);
    return ApiHelper(url, { method: "POST", body }).then((data: Response) => {
        if (data.status !== 200) {
            return Promise.reject(data.statusText);
        }
        return data.json();
    });
};

export const setInternationalizationDataOnServer = (bodayData: { curr: string }): Promise<any> => {
    const url = getUrl(ROUTES.SET_COUNTRY_CURRENCY_SETTINGS_ON_SERVER);

    return ApiHelper(url, { method: "POST", body: { currency: bodayData.curr } }).then(
        (data: Response) => {
            if (data.status !== 200) {
                return Promise.reject(data.statusText);
            }
            return data.json();
        }
    );
};
